import Cropper from "react-easy-crop";
import type { Area } from "react-easy-crop";

interface BannerCropperProps {
  image: string;
  crop: { x: number; y: number };
  zoom: number;
  aspect: number;
  onCropChange: (location: { x: number; y: number }) => void;
  onCropComplete: (croppedArea: Area, croppedAreaPixels: Area) => void;
  onZoomChange: (zoom: number) => void;
}

export function BannerCropper({
  image,
  crop,
  zoom,
  aspect,
  onCropChange,
  onCropComplete,
  onZoomChange,
}: BannerCropperProps) {
  return (
    <Cropper
      image={image}
      crop={crop}
      zoom={zoom}
      aspect={aspect}
      onCropChange={onCropChange}
      onCropComplete={onCropComplete}
      onZoomChange={onZoomChange}
    />
  );
}
